
import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import { tr } from 'date-fns/locale';
import { Button } from '@/components/ui/button';
import { Globe, Calendar, Download } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { AnalysisHistory, saveToFile } from '@/utils/analysisHelpers';

interface ScanHistoryProps {
  history: AnalysisHistory[];
}

export const ScanHistory: React.FC<ScanHistoryProps> = ({ history }) => {
  const navigate = useNavigate();

  if (history.length === 0) return null;

  const formatDate = (dateString: string) => {
    try {
      const date = new Date(dateString);
      return formatDistanceToNow(date, { locale: tr, addSuffix: true });
    } catch (error) {
      return 'geçersiz tarih';
    }
  };

  return (
    <div className="space-y-2">
      <h3 className="text-sm font-medium">Son Taramalar:</h3>
      <div className="border rounded-lg overflow-hidden">
        {history.slice(0, 5).map((scan, index) => (
          <div 
            key={index} 
            className="flex justify-between items-center p-3 hover:bg-muted/50 border-b last:border-b-0"
            onClick={() => navigate(`/analysis/${scan.domain}`)}
            style={{ cursor: 'pointer' }}
          >
            <div className="flex items-center">
              <Globe className="h-4 w-4 mr-2 text-primary" />
              <span>{scan.domain}</span>
            </div>
            <div className="flex items-center space-x-3 text-sm text-muted-foreground">
              <span>{scan.urlCount} URL</span>
              <span className="flex items-center">
                <Calendar className="h-3 w-3 mr-1" />
                {formatDate(scan.date)}
              </span>
            </div>
          </div>
        ))}
      </div>
      <div className="flex justify-end">
        <Button 
          variant="ghost" 
          size="sm"
          onClick={() => saveToFile(JSON.stringify(history, null, 2), 'tarama_gecmisi.txt')}
        >
          <Download className="h-4 w-4 mr-1" />
          Tüm Geçmişi İndir
        </Button>
      </div>
    </div>
  );
};
